import { styled } from '@mui/material/styles';
import { MenuItem } from '@mui/material';

import { COLOR, TRANSPARENT_COLOR } from '@src/styles/color';

const StyledSpeed = styled('div')(({ disabled, active, width }) => ({
  display: 'flex',
  alignItems: 'center',
  padding: '4px 6px',
  borderRadius: '12px',
  width: 'fit-content',

  '.dropdown-container': {
    display: 'flex',
    alignItems: 'center',
    gap: '4px',
    justifyContent: 'center',
    height: '24px',
    cursor: 'pointer',
  },

  '&:hover': {
    background: disabled ? 'transparent' : COLOR.secondary[80],
  },

  '.disabled': {
    cursor: 'not-allowed',
    background: 'transparent',
    color: COLOR.redPrimary,
    '&:hover': {
      background: 'transparent',
      cursor: 'not-allowed',
    },
  },

  '.dropdown-container:focus-visible': {
    outline: 'none',
  },

  [active]: {
    background: TRANSPARENT_COLOR.primary,
    '&:hover': {
      background: TRANSPARENT_COLOR.primary,
    },
  },

  '.MuiAutocomplete-root': {
    width: '100%',
  },

  '.text-field': {
    width: width || '100%',
    minWidth: width || '55px',
  },

  '.MuiOutlinedInput-notchedOutline': {
    border: 'none',
  },

  '.MuiOutlinedInput-root': {
    padding: '0 5px !important',
    width: '100%',
  },

  '.MuiAutocomplete-input': {
    color: COLOR.darkBlue,
  },

  input: {
    padding: '0 !important',
    color: COLOR.text,
    fontSize: '14px',
  },

  '.MuiAutocomplete-endAdornment': {
    right: '-7px !important',
  },
}));

const StyledMenuItem = styled(MenuItem)`
  padding: 10px;
  grid-template-columns: 50px 100px;
  grid-gap: 10px;
  display: grid;
  cursor: pointer;
  color: ${(props) => props.active && COLOR.darkBlue};
  background-color: ${(props) => props.active && COLOR.primary40};

  &:hover {
    color: ${(props) => (props.active ? COLOR.darkBlue : COLOR.text)};
    background-color: ${(props) =>
      props.active ? COLOR.primary40 : TRANSPARENT_COLOR.dark};
  }

  .text {
    font-weight: ${(props) => (props.active ? '500' : '400')};
  }
`;

const StyledListMenuItem = styled('div')`
  padding: ${(props) => props.metaData?.paddingListMenuItemHover || '8px'};
  padding-top: ${(props) => props.searchable && '0px'};
  border-radius: 8px;
  height: ${(props) =>
    props.overflow ? props.metaData?.maxHeightList : 'auto'};
  overflow-y: auto;

  .dropdown__menu_item {
    .speed-value {
      width: 48px;
    }
  }

  &.scrollbar-custom {
    &::-webkit-scrollbar {
      width: 8px;
      height: 8px;
    }
    &::-webkit-scrollbar-track {
      background: ${COLOR.white};
    }
    &::-webkit-scrollbar-thumb {
      background: ${COLOR.tooltipColor};
      border-radius: 100px;
    }
    &::-webkit-scrollbar-thumb:hover {
      background: ${COLOR.tooltipColor};
      border-radius: 100px;
    }
  }
  &.hidden-scrollbar {
    &::-webkit-scrollbar {
      width: 0px;
      background: transparent;
    }
  }
`;

const PopoverMenuItem = styled('div')`
  padding: 8px 12px;
  box-sizing: border-box;
  cursor: pointer;
  width: 100%;
  display: flex;
  align-items: center;
  color: ${(props) => props.active && COLOR.darkBlue};
  background-color: ${(props) => props.active && '#1E164E14'};
  display: flex;
  gap: 10px;
  margin-bottom: ${(props) => props.metaData?.marginBottom || '0px'};
  &:hover {
    color: ${(props) => (props.active ? COLOR.darkBlue : COLOR.text)};
    background-color: ${(props) =>
      props.active ? '#1E164E14' : TRANSPARENT_COLOR.dark};
  }
  &.disabled {
    pointer-events: auto;
    cursor: not-allowed !important;
    opacity: 0.5;
  }
  &.selected {
    background-color: ${COLOR.activeMenu};
  }
`;

const StyledCustomSpeed = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 4px;

  .custom-speed-wrapper {
    padding: 0px 8px 0px 8px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
  }

  .MuiOutlinedInput-input {
    padding: 6px 12px;
    border-radius: 8px;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
  }

  .MuiOutlinedInput-root {
    border-radius: 8px;
  }

  .error-text {
    padding: 0px 8px;
  }
`;

export {
  StyledSpeed,
  StyledMenuItem,
  StyledListMenuItem,
  PopoverMenuItem,
  StyledCustomSpeed,
};
